const initialApiState = {
    name: '',
    description: '',
    basePath: '',
    version: '',
    relatedCategories: [],
    image: undefined,
    typeImage: '',
    detailedDescription: '',
    benefits: '',
    target: "Bancos",
    provider: 0,
    keyword: [],
    subscriptions: [],
    commentaries: [],
    endpointsApi: [],
    groupsApi: [],
    plansApi: [],
    dataSwagger: '',
    providerKey: ''
}

const mutations = {
    setChartLoanding: (state, payload) => {
        state.chartLoanding = payload;
    },
    setChartList: (state, payload) => {
        state.chartList = payload;
    },
    setChart: (state, payload) => {
        state.chart = { ...state.chart, ...payload };
    },
    setBackgroundColorChart: (state, payload) => {
        state.chart.chartData.datasets[0].backgroundColor.push(payload);
    },
    setDataChart: (state, payload) => {
        state.chart.chartData.datasets[0].data.push(payload);
    },
    setLabelsChart: (state, payload) => {
        state.chart.chartData.labels = payload;
    },
    setApis: (state, payload) => {
        state.apis = payload;
    },
    setApi: (state, payload) => {
        state.api = { ...state.api, ...payload };
    },
    setResetApiState: (state) => {
        state.api = { ...initialApiState };
        state.api.groupsApi = []
        state.api.endpointsApi = []
        state.api.plansApi = []
        state.businessModelType = ''
    },
    setApprovalApi: (state, payload) => {
        state.api.approval = payload;
    },
    setNameApi: (state, payload) => {
        state.api.name = payload;
    },
    setImage: (state, payload) => {
        state.api.image = payload;
    },
    setTypeImage: (state, payload) => {
        state.api.typeImage = payload;
    },
    setProvider: (state, payload) => {
        state.api.provider = payload;
    },
    setRelatedCategories: (state, payload) => {
        state.api.relatedCategories = payload;
    },
    setDescription: (state, payload) => {
        state.api.description = payload;
    },
    setDetailedDescription: (state, payload) => {
        state.api.detailedDescription = payload;
    },
    setDataSwagger: (state, payload) => {
        state.api.dataSwagger = payload;
    },
    setVersion: (state, payload) => {
        state.api.version = payload;
    },
    setBasePath: (state, payload) => {
        state.api.basePath = payload;
    },
    setMateriaisUteis: (state, payload) => {
        state.materiaisUteis = payload;
    },
    setEditMaterials: (state, payload) => {
        state.materiaisUteis.splice(payload.index, 1, payload.material)
    },
    setAddItemMateriaisUteis: (state, payload) => {
        if (!state.materiaisUteis) {
            state.materiaisUteis = []
        }
        state.materiaisUteis.push(payload)
    },
    setDeleteItemMateriaisUteis: (state, payload) => {
        state.materiaisUteis.splice(payload, 1)
    },
    setEndpoints: (state, payload) => {
        state.api.endpointsApi = payload
    },
    setEditEndpoint: (state, payload) => {
        state.api.endpointsApi.splice(payload.endpointApi.index, 1, payload.endpointApi)
    },
    setGroupList: (state, items) => {
        state.api.groupsApi = items
    },
    setNewGroup: (state, item) => {
        state.api.groupsApi.unshift(item)
    },
    setRemoveGroup: (state, index) => {
        state.api.groupsApi.splice(index, 1)
    },
    setEditGroup: (state, payload) => {
        state.api.groupsApi.splice(payload.index, 1, payload.group)
    },
    setPlanList: (state, items) => {
        state.api.plansApi = items
    },
    setNewPlan: (state, item) => {
        state.api.plansApi.push(item)
    },
    setRemovePlan: (state, index) => {
        state.api.plansApi.splice(index, 1)
    },
    setEditPlan: (state, payload) => {
        state.api.plansApi.splice(payload.index, 1, payload.plan)
    },
    setBusinessModelType: (state, items) => {
        state.businessModelType = items
    },
    setFormHasChanged: (state, payload) => {
        state.formHasChanged = payload;
    },
    setMateriaisUteisHasChanged: (state, payload) => {
        state.materiaisUteisHasChanged = payload;
    },
    setRegisterApiTab: (state, payload) => {
        state.registerApiTab = payload;
    },
    setRecentlyChangedApi: (state, payload) => {
        state.recentlyChangedApi = payload;
    },
    setApiDetailsLoading: (state, payload) => {
        state.apiDetailsLoading = payload;
    }
};

export default mutations;
